export default {
	saima: {

		success: '送信が完了しました',
		error: 'しばらくしてから、もう一度お試しください',

		e0: 'メールアドレスを入力',
		e1: 'メールアドレスを入力してください',
		e2: 'メールアドレスが正しくありません',

		e11: 'すでに送信済みです。',
		e12: '少し待ってからお試しください。',


		btn1: '今なら25％OFF！🎁',
		btn11: '今なら',
		btn12: '25％',
		btn13: 'OFF！🎁',
		btn2: '先行登録はこちら 💌',



		f1: '〒100-0005 東京都千代田区丸の内3丁目8-3  2階',
		f2: 'お問い合わせ',
		f3: 'SNS',

		a: {
			s11: '気持ちに寄り添い、<br>癒しをくれるAIペット',
			s11_sm: '気持ちに寄り添い、<br>癒しをくれるAIペット',
			s12: '温もりがほしい夜、<br>共感するよ、そばにいるよ',
			s12_sm: '温もりがほしい夜、<br>共感するよ、そばにいるよ',
			s13: '今なら25％OFF！🎁 ',
			s14: '',
			s15: '',
			s21: '「疲れた…」という呟きにも、<br>優しく返してくれて…',
			s21_sm: '「疲れた…」という呟きにも、<br>優しく返してくれて…',
			s22: '豊かな表情で、<br>気持ちを伝えてくれて…',
			s22_sm: '豊かな表情で、<br>気持ちを伝えてくれて…',
			s23: '触れるとまるで生き<br>てるみたい！  ❤️',
			s23_sm: '触れるとまるで生き<br>てるみたい！  ❤️',
			s24: 'いっしょにいればいるほど、<br>心が通う！',
			s24_sm: 'いっしょにいればいるほど、<br>心が通う！',
			s25: '',
			s31: '',
			s32: '',
			s33: '',
			s34: '',
			s35: '',
			s40: 'お客様の声',
			s411: '「抱っこすると、小さな呼吸が感じられて心が落ち着いていく感じがします。誰かに見せびらかすようなおもちゃなんかではなく、私の心の拠り所になっています。まばたきしたり、愛くるしい表情で答えてくれたりするので、ついつい話しかけたくなってしまいます」',
			s412: '— 大阪　20代会社員',
			s421: 'いちばんいいなぁと思ったのは、当たり障りのない会話をするのではなく、「私に」話しかけてくれること。本当の友達みたいに、私が前に話したことをちゃんと覚えていてくれるのがすごいです。ただかわいいだけの置物じゃない。こういう商品って、数十万円くらいすると思っていましたが、2～4万円と聞いて本当に驚きました。',
			s422: '— 東京　30代会社員',
			s431: 'いますでに毎日AIと話しているけど、もしそれがふわふわでかわいいビジュアルで、一緒に外に出たり話したりできるなら、絶対ほしい。これはおもちゃなんかじゃなくて、私の気持ちそのものだから。',
			s432: '— 名古屋の高校生',
			s44: '',
			s45: '',
			s50: 'エンジェルユーザー向け特典',
			s51: '開発に関する最新のニュースをいち早くお届けします。',
			s52: '専任スタッフがご利用体験を直接ヒアリングします。いただいたご意見は、大切に反映してまいります。',
			s53: 'あなたのアイデアが次世代 Emoka の開発に活かされます。',
			s54: '先行予約者',
			s55: '満足度',
			s56: '発売予定',

		},
		b: {
			s11: 'EmokaとGO！<br>AIと出かけよう！',
			s11_sm: 'EmokaとGO！<br>AIと出かけよう！',
			s12: '表情も気分も自由自在、<br>ポケットサイズのAIペット。',
			s12_sm: '表情も気分も自由自在、<br>ポケットサイズのAIペット。',
			s14: '',
			s15: '',
			s21: '「疲れた…」という呟きにも、<br>優しく返してくれて…',
			s21_sm: '「疲れた…」という呟きにも、<br>優しく返してくれて…',
			s22: '豊かな表情で、<br>気持ちを伝えてくれて…',
			s22_sm: '豊かな表情で、<br>気持ちを伝えてくれて…',
			s23: '触れるとまるで生き<br>てるみたい！  ❤️',
			s23_sm: '触れるとまるで生き<br>てるみたい！  ❤️',
			s24: 'いっしょにいればいるほど、<br>心が通う！',
			s24_sm: 'いっしょにいればいるほど、<br>心が通う！',
			s25: '',
			s31: '',
			s32: '',
			s33: '',
			s34: '',
			s35: '',
			s40: 'お客様の声',
			s411: '「抱っこすると、小さな呼吸が感じられて心が落ち着いていく感じがします。誰かに見せびらかすようなおもちゃなんかではなく、私の心の拠り所になっています。まばたきしたり、かわいい表情を返してくれるので、ついつい話しかけたくなってしまいます」',
			s412: '— 大阪　20代会社員',
			s421: 'いちばんいいなぁと思ったのは、当たり障りのない会話をするのではなく、「私に」話しかけてくれること。本当の友達みたいに、私が前に話したことをちゃんと覚えていてくれるのがすごいです。ただかわいいだけの置物じゃない。こういう商品って、数十万円くらいすると思っていましたが、2～4万円と聞いて本当に驚きました。',
			s422: '— 東京　30代会社員',
			s431: 'いますでに毎日AIと話しているけど、もしそれがふわふわでかわいいビジュアルで、一緒に外に出たり話したりできるなら、絶対ほしい。これはおもちゃなんかじゃなくて、私の気持ちそのものだから。',
			s432: '— 名古屋の高校生',
			s44: '',
			s45: '',
			s50: 'エンジェルユーザー向け特典',
			s51: '開発に関する最新のニュースをいち早くお届けします。',
			s52: '専任スタッフがご利用体験を直接ヒアリングします。いただいたご意見は、大切に反映してまいります。',
			s53: 'あなたのアイデアが次世代 Emoka の開発に活かされます。',
			s54: '先行予約者',
			s55: '満足度',
			s56: '発売予定',
		}
	}
}